module.exports = __webpack_public_path__ + "static/img/akum_600_100.55afbb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/akumulator/akum_600_100.svg
// module id = jncb
// module chunks = 1